import React from 'react';
import Step2 from '../../../components/Visitor/Request/Step2';

const Step2Request = () => {
    return (
        <div className="min-h-screen bg-black pt-28 pb-12 px-4 md:px-6">
            <Step2 />
        </div>
    );
};

export default Step2Request;
